import React from "react";
import { GraduationCap } from "lucide-react";
import { useDashTheme } from "../hooks/useDashTheme";
import { PageShell } from "../components/PageShell";
import { Card } from "../components/primitives";
import KnowSkills from "../../../components/KnowSkills/KnowSkills";

// Per-person AI skill profiles: activity-derived skill clusters, automation
// readiness score, activity timeline, and a downloadable SKILL.md/JSON
// hand-off. Moved out of Org Intelligence's tab bar into its own Growth
// sidebar destination — this is its own workflow, not a sub-view of the
// org-wide risk/issues report.
export default function SkillProfilesV2() {
  const t = useDashTheme();
  return (
    <PageShell
      eyebrow="AI · Team skills"
      title="Skill Profiles"
      subtitle="Per-person skill clusters, automation readiness, and activity timelines"
      icon={<GraduationCap size={22} />}
    >
      <Card padding={t.s[2]}><KnowSkills /></Card>
    </PageShell>
  );
}
